import React from 'react';
import { Button } from '@/components/ui';

interface ActionsCellProps {
  actions?: Array<{
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  }>;
  render?: () => React.ReactNode;
}

function ActionsCell({ actions, render }: ActionsCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className="data-cell__actions">
      {actions.map((action, index) => (
        <Button
          isIconOnly
          key={index}
          onClick={action.onClick}
          // className="data-cell__action-button"
          title={action.label}
        >
          {action.icon || action.label}
        </Button>
      ))}
    </div>
  );
}

export default ActionsCell;
